/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate body fat percentage with the US Navy circumference method.`)
};

const es_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima el porcentaje de grasa corporal con el método de circunferencias de la Marina de EE. UU.`)
};

const de_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätze deinen Körperfettanteil mit der US-Navy-Umfangsmethode.`)
};

const nl_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat het lichaamsvetpercentage met de omtrekmethode van de Amerikaanse marine.`)
};

const fr_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez le pourcentage de masse grasse avec la méthode des circonférences de la marine américaine.`)
};

const it_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima la percentuale di grasso corporeo con il metodo delle circonferenze della Marina statunitense.`)
};

const pt_br2_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o percentual de gordura corporal com o método de circunferência da Marinha dos EUA.`)
};

const pt_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime a percentagem de gordura corporal com o método de circunferências da Marinha dos EUA.`)
};

const ja_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米海軍式の周囲径法で体脂肪率を推定します。`)
};

const zh_bf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用美国海军围度法估算体脂率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_tool_description", locale)
	if (locale === "en") return en_bf_tool_description(inputs)
	if (locale === "es") return es_bf_tool_description(inputs)
	if (locale === "de") return de_bf_tool_description(inputs)
	if (locale === "nl") return nl_bf_tool_description(inputs)
	if (locale === "fr") return fr_bf_tool_description(inputs)
	if (locale === "it") return it_bf_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_bf_tool_description(inputs)
	if (locale === "pt") return pt_bf_tool_description(inputs)
	if (locale === "ja") return ja_bf_tool_description(inputs)
	return zh_bf_tool_description(inputs)
};